<template>
  <modal class="modalCG" @before-open="iphoneModalsSet" @before-close="closingModal" @opened="initStripe" name="modalPayment" height="auto" :adaptive="true" :scrollable="true">
    <div class="modal-box">
      <div class="modal-header">
        <h2>Neue Zahlungsmethode</h2>
        <span class="close" @click.prevent="close()">
          <icon name="close" scale="2"></icon>
        </span>
      </div>
        <div class="modal-body text-center">
          <form>
          <div class="form-field sized">
            <label for="cardholder-name" >Karten-Inhaber</label>
            <input v-model="cardholderName" v-validate="'required'" name="cardholderName" :class="{'error': errors.has('cardholderName') }" type="text" id="cardholder-name" placeholder="Karten-Inhaber">
            <span v-show="errors.has('cardholderName')" class="errorMsg">{{ errors.first('cardholderName') }}</span>
          </div>
          <div class="form-field sized">
            <label for="card-element" >Deine Kreditkarte</label>
            <div id="card-element">
              <!-- a Stripe Element will be inserted here. -->
            </div>
            <div id="card-errors" role="alert"></div>
          </div>
          </form>
        </div>
        <div class="modal-action">
          <button type="button" class="btn green" @click.prevent="addCard()">Speichern</button>
        </div>

    </div>
  </modal>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import {EventBus} from '@/assets/js/event-bus.js'
  import helpers from '@/mixins/helpers.js'
  import formatting from '@/mixins/formatting.js'

  export default {
    name: 'paymentModal',
    mounted () {
      EventBus.$on('togglePaymentModal', () => {
        this.toggleModal()
      })
      EventBus.$on('escKey', () => {
        this.close()
      })
    },
    beforeDestroy () {
      EventBus.$off('escKey')
    },
    data () {
      return {
        show: false,
        cardholderName: '',
        card: null,
        stripe: null,
        elements: null,
        saveToast: null,
        intent: {
          hash: '',
          intent_id: '',
          client_secret: ''
        },
        style: {
          base: {
            color: '#32325d',
            lineHeight: '18px',
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '16px',
            '::placeholder': {
              color: '#aab7c4'
            }
          },
          invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
          }
        }
      }
    },
    mixins: [helpers, formatting],
    methods: {
      ...mapActions([
        'savePaymentDetail',
        'savePaymentDetailIntent'
      ]),
      initStripe () {
        var self = this
        self.cardholderName = ''
        var cb = (intent) => {
          self.intent = intent
          self.stripe = window.Stripe(self.stripeKey)
          self.elements = self.stripe.elements({locale: 'de'})
          self.card = self.elements.create('card', {style: self.style})
          self.card.mount('#card-element')
        }
        var errorCb = () => {
          self.close()
          self.saveToast.goAway(100)
          self.saveToast = null
          self.$toasted.error('Leider ist ein Fehler aufgetreten.', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            action: {
              text: 'X',
              class: 'toastBtn',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
            icon: 'close'
          })
        }
        this.savePaymentDetailIntent({cb, errorCb})
      },
      toggleModal () {
        this.show = !this.show
        this.show ? this.$modal.show('modalPayment') : this.$modal.hide('modalPayment')
      },
      closingModal () {
        this.show = false
        this.iphoneModalsUnset()
      },
      saveCard (token) {
        var self = this
        var cb = (payment) => {
          self.close()
          self.saveToast.goAway(100)
          self.saveToast = null
          self.$toasted.success('Die Zahlungsmethode wurde gespeichert.', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            action: {
              text: 'X',
              class: 'toastBtn',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
            icon: 'check'
          })
          self.emitPM(payment)
        }
        var errorCb = () => {
          self.close()
          self.saveToast.goAway(100)
          self.saveToast = null
          self.$toasted.error('Leider ist ein Fehler aufgetreten.', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            action: {
              text: 'X',
              class: 'toastBtn',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
            icon: 'close'
          })
        }
        this.savePaymentDetail({hash: self.intent.hash, token: token, cb, errorCb})
      },
      addCard () {
        var self = this
        self.$validator.validateAll().then((result) => {
          if (result) {
            if (!self.saveToast) {
              self.saveToast = self.$toasted.info('Wird gespeichert...', {
                theme: 'primary',
                position: 'top-right',
                duration: 10000,
                icon: 'info'
              })
              var cardData = {
                payment_method_data: {
                  billing_details: {
                    name: self.cardholderName
                  }
                }
              }
              self.stripe.handleCardSetup(self.intent.client_secret, self.card, cardData).then(
                result => {
                  if (result.error) {
                    // Inform the user if there was an error
                    self.saveToast.goAway(100)
                    self.saveToast = null
                    var errorElement = document.getElementById('card-errors')
                    errorElement.textContent = result.error.message
                    self.$toasted.error('Die Karte wurde von Stripe abgelehnt.', {
                      theme: 'primary',
                      position: 'top-right',
                      duration: 10000,
                      action: {
                        text: 'X',
                        class: 'toastBtn',
                        onClick: (e, toastObject) => {
                          toastObject.goAway(0)
                        }
                      },
                      icon: 'close'
                    })
                  } else {
                    // Send the token to your server
                    self.saveCard(result.setupIntent)
                  }
                },
                error => {
                  console.log(error)
                }
              )
            }
          }
        })
      },
      emitPM (pm) {
        this.$emit('saved', pm)
      },
      close () {
        this.$emit('close')
      }
    },
    computed: {
      ...mapGetters({
        'stripeKey': 'auth_stripe_key'
      })
    }
  }
</script>

<style>
  /**
 * The CSS shown here will not be introduced in the Quickstart guide, but shows
 * how you can use CSS to style your Element's container.
 */
  .StripeElement {
    background-color: white;
    height: 40px;
    padding: 10px 12px;
    border-radius: 4px;
    border: 1px solid transparent;
    box-shadow: 0 1px 3px 0 #e6ebf1;
    -webkit-transition: box-shadow 150ms ease;
    transition: box-shadow 150ms ease;
  }

  .StripeElement--focus {
    box-shadow: 0 1px 3px 0 #cfd7df;
  }

  .StripeElement--invalid {
    border-color: #fa755a;
  }

  .StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/Payment.vue